export const PDF_MIME_TYPE = "application/pdf";

export const isPdfFile = (file) => file.mime_type === PDF_MIME_TYPE;

// Attachments are images or PDFs; anything that is not a PDF counts as an image.
export const countFileTypes = (files) => {
  const attachments = files ?? [];
  const pdfs = attachments.filter(isPdfFile).length;
  return { images: attachments.length - pdfs, pdfs };
};
